import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-autocomplete',
  templateUrl: './autocomplete.component.html',
  styleUrls: ['./autocomplete.component.css'],
  standalone: false
})
export class AutocompleteComponent {
  @Output()
  optionSelected = new EventEmitter<any>();

  @Input()
  formGroup!: FormGroup;

  @Input()
  controlName!: string;

  @Input()
  displayFn!: (item: any) => string;

  @Input()
  items: any[] | null = [];

  @Input()
  placeholder!: string;

  @Input()
  displaySearchIcon = false;

  @Input()
  showDropdownIcon = true;

  @Input()
  multilineOptions = false;

  get control(): FormControl {
    return this.formGroup.get(this.controlName) as FormControl;
  }
}
